import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { OpalApiResponseDocument } from '../../../schema'
import { users } from '../../../v2/users'
import { globalQueryKeys } from '../../queryKeys'

type UserDocument = OpalApiResponseDocument<'ReadUsersV2', 200>

export const useWorkspaceUsers = <T = UserDocument>({
  workspaceId,
  select,
}: {
  workspaceId: string
  select?: (data: UserDocument) => T
}): UseQueryResult<T, unknown> => {
  return useQuery({
    queryKey: globalQueryKeys.workspaceUsers(workspaceId),
    queryFn: () =>
      users.read({
        query: {
          filter: {
            brand_id: [parseInt(workspaceId, 10)],
          },
          include: ['avatar_asset_reference'],
        },
      }),
    select,
  })
}
